import { FormType } from '../../../form-types';
import { SuboxoneQuestionFieldAnswers } from '../questions';

export const suboxone: FormType<SuboxoneQuestionFieldAnswers> = {
  name: 'Suboxone',
  questions: [
    {
      key: 'suboxone_telemedicineConsent',
      next: {
        condition: { 'suboxone_telemedicineConsent.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_emergencySymptoms'
      }
    },
    {
      key: 'suboxone_emergencySymptoms',
      next: {
        condition: { 'suboxone_emergencySymptoms.yes': true },
        key: 'suboxone_emergencyReferral',
        els: 'suboxone_sexAssignedAtBirth'
      }
    },
    {
      key: 'suboxone_sexAssignedAtBirth',
      next: {
        condition: { 'suboxone_sexAssignedAtBirth.female': true },
        key: 'suboxone_pregnancyStatus',
        els: 'suboxone_heightFeet'
      }
    },
    {
      key: 'suboxone_pregnancyStatus',
      next: {
        condition: { 'suboxone_pregnancyStatus.yes': true },
        key: 'suboxone_ineligible',
        els: 'suboxone_pregnancyConsent'
      }
    },
    {
      key: 'suboxone_pregnancyConsent',
      next: {
        condition: { 'suboxone_pregnancyConsent.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_heightFeet'
      }
    },
    'suboxone_heightFeet',
    'suboxone_weightPounds',
    {
      key: 'suboxone_primaryGoal',
      next: {
        condition: { 'suboxone_primaryGoal.other': true },
        key: 'suboxone_primaryGoalOther',
        els: 'suboxone_opioidDuration'
      }
    },
    'suboxone_primaryGoalOther',
    'suboxone_opioidDuration',
    {
      key: 'suboxone_primaryOpioids',
      next: {
        condition: { 'suboxone_primaryOpioids.other': true },
        key: 'suboxone_otherOpioids',
        els: 'suboxone_opioidRoutes'
      }
    },
    'suboxone_otherOpioids',
    'suboxone_opioidRoutes',
    'suboxone_lastOpiateUse',
    'suboxone_lastOpioidDetails',
    {
      key: 'suboxone_withdrawalSymptoms',
      next: {
        condition: { 'suboxone_withdrawalSymptoms.yes': true },
        key: 'suboxone_cowsHeartRate',
        els: 'suboxone_cravingSeverity'
      }
    },
    'suboxone_cowsHeartRate',
    'suboxone_cowsSweating',
    'suboxone_cowsRestlessness',
    'suboxone_cowsPupilSize',
    'suboxone_cowsBoneMuscleAches',
    'suboxone_cowsRunnyNose',
    'suboxone_cowsGiSymptoms',
    'suboxone_cowsTremor',
    'suboxone_cowsYawning',
    'suboxone_cowsAnxiety',
    'suboxone_cowsGoosebumps',
    'suboxone_cravingSeverity',
    'suboxone_priorOverdose',
    {
      key: 'suboxone_priorTreatment',
      next: {
        switch: [
          {
            condition: { 'suboxone_priorTreatment.within_12_months': true },
            key: 'suboxone_priorTreatments'
          },
          {
            condition: { 'suboxone_priorTreatment.over_12_months': true },
            key: 'suboxone_priorTreatments'
          }
        ],
        els: 'suboxone_benzodiazepineUse'
      }
    },
    {
      key: 'suboxone_priorTreatments',
      next: {
        switch: [
          {
            condition: {
              'suboxone_priorTreatments.buprenorphine_naloxone': true
            },
            key: 'suboxone_buprenorphineStopReasons'
          },
          {
            condition: { 'suboxone_priorTreatments.buprenorphine_mono': true },
            key: 'suboxone_buprenorphineStopReasons'
          }
        ],
        els: 'suboxone_benzodiazepineUse'
      }
    },
    {
      key: 'suboxone_buprenorphineStopReasons',
      next: {
        switch: [
          {
            condition: {
              'suboxone_buprenorphineStopReasons.side_effects': true
            },
            key: 'suboxone_buprenorphineSideEffects'
          },
          {
            condition: {
              'suboxone_buprenorphineStopReasons.other_reasons': true
            },
            key: 'suboxone_buprenorphineStopReasonsOther'
          }
        ],
        els: 'suboxone_benzodiazepineUse'
      }
    },
    {
      key: 'suboxone_buprenorphineSideEffects',
      next: {
        switch: [
          {
            condition: { 'suboxone_buprenorphineSideEffects.other': true },
            key: 'suboxone_buprenorphineSideEffectsOther'
          },
          {
            condition: {
              'suboxone_buprenorphineStopReasons.other_reasons': true
            },
            key: 'suboxone_buprenorphineStopReasonsOther'
          }
        ],
        els: 'suboxone_benzodiazepineUse'
      }
    },
    {
      key: 'suboxone_buprenorphineSideEffectsOther',
      next: {
        condition: {
          'suboxone_buprenorphineStopReasons.other_reasons': true
        },
        key: 'suboxone_buprenorphineStopReasonsOther',
        els: 'suboxone_benzodiazepineUse'
      }
    },
    'suboxone_buprenorphineStopReasonsOther',
    {
      key: 'suboxone_benzodiazepineUse',
      next: {
        switch: [
          {
            condition: { 'suboxone_benzodiazepineUse.daily': true },
            key: 'suboxone_ineligible',
          },
          {
            condition: { 'suboxone_benzodiazepineUse.occasionally': true },
            key: 'suboxone_benzodiazepineConsent',
          },
        ],

        els: 'suboxone_medicalConditions'
      }
    },
    {
      key: 'suboxone_benzodiazepineConsent',
      next: {
        condition: { 'suboxone_benzodiazepineConsent.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_medicalConditions'
      }
    },
    {
      key: 'suboxone_medicalConditions',
      next: {
        condition: { 'suboxone_medicalConditions.none': true },
        key: 'suboxone_medications',
        els: 'suboxone_ineligible'
      }
    },
    {
      key: 'suboxone_medications',
      next: {
        condition: { 'suboxone_medications.none': true },
        key: 'suboxone_naloxonePrescription',
        els: 'suboxone_ineligible'
      }
    },
    'suboxone_naloxonePrescription',
    {
      key: 'suboxone_precipitatedWithdrawalConsent',
      next: {
        condition: {
          'suboxone_precipitatedWithdrawalConsent.non_consent': true
        },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_additionalQuestions'
      }
    },
    'suboxone_additionalQuestions',
    {
      key: 'suboxone_consentTruthfulness',
      next: {
        condition: { 'suboxone_consentTruthfulness.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_consentOUD'
      }
    },
    {
      key: 'suboxone_consentOUD',
      next: {
        condition: { 'suboxone_consentOUD.non_consent': true },
        key: 'suboxone_didNotConsent',
        els: 'suboxone_complete'
      }
    },
    'suboxone_complete',
    'suboxone_ineligible',
    'suboxone_didNotConsent'
  ]
};
